import { Typography } from '@compass/components'
import { cn } from '@compass/utils'
import { PropsWithChildren } from 'react'

import { CellWrapper } from './CellAction'

export function MissingData({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <CellWrapper>
      <Typography className={cn('text-gray-600 italic', className)}>{children}</Typography>
    </CellWrapper>
  )
}

export function Unavailable() {
  return <MissingData>-</MissingData>
}

export function Unset() {
  return <MissingData>-</MissingData>
}

export function NotApplicable() {
  return <MissingData>-</MissingData>
}
